import * as React from 'react';
import { Image, FlatList, Text, View, StyleSheet, Platform, Pressable } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { useSelector, useDispatch } from 'react-redux';
import { Divider } from 'react-native-paper';
import { SearchLauncher } from '../components/SearchLauncher';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingRight: 5,
    flexWrap: "wrap",
  },
  labelPadLeft: {
    fontSize: 18,
    fontWeight: "bold",
    paddingLeft: 10,
    paddingTop: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexWrap: "wrap",
    flex: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    flexDirection: "row",
    marginBottom: 15,
    flexShrink: 1,
  },
  line2: {
    flexDirection: "row",
    marginBottom: 25,
    marginTop: 10,
    flexShrink: 1,
  },
  line3: {
    flexDirection: "row",
    marginBottom: 15,
    flexShrink: 1,
    paddingLeft: 10,
  },
  listItemStyle: {
    paddingLeft: 5,
  },
  listItemLeftIcon: {
    marginRight: 0,
  },
  mainList: {
    flexGrow: 0,
  },
  kittemListItem: {
    backgroundColor: "transparent",
  },
  link: {
    color: "#0000EE",
    textDecorationLine: "underline",
  },
  subtitle: {
    marginVertical: 20,
    fontWeight: "600",
    color: "#6f6f6f",
  },
  legendWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },
  legendTitle: {
    fontWeight: "bold",
    paddingLeft: 5,
    paddingBottom: 2,
  },
  legendSubtitle: {
    paddingLeft: 5,
  },
  listWrapper: {
    flexGrow: 1,
    padding: 10,
  },
  searchWrapper: {
    padding: 10,
    paddingTop: 0,
    minHeight: 75,
    //maxHeight: 300,
  },
  descriptionWrapper: {
    paddingHorizontal: 10,
  },
});

export function AllProducers({ route, navigation }) {
  const { showPermanentSnack, hideSnack, showSpinner, hideSpinner } = React.useContext(AppContext);
  const [filteredProducers, setFilteredProducers] = React.useState(null);
  const dataFilter = useSelector((state) => state.dataFilter);

  async function load() {
    try {
      showSpinner();
      hideSnack();

      AppUtilities.info("AllProducers.load fetching");

      const response = await AppUtilities.fetchUnauthorized(
        "AllProducers.load",
        "/find_humane/api/producers?" + AppUtilities.convertFilterHashToQueryParametersSorted(dataFilter),
        "GET",
      );

      if (response.body) {
        hideSpinner();
        setFilteredProducers(response.body.producers);
      } else {
        throw new Error("Result body not found");
      }
    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", load);
      hideSpinner();
      AppUtilities.handleException(e, "AllProducers.load");
    }
  }

  React.useEffect(() => {
    if (dataFilter) {
      load();
    }
  }, [dataFilter]);

  const renderItem = ({ item, index }) => {
    const leftAccessory = item.accessoryLeft ? item.accessoryLeft() : null;
    return (
      <Pressable key={item.i} onPress={item.onPress}>
        <View style={{ flex: 1, flexDirection: "row", alignItems: "center", backgroundColor: "#ffffff", padding: 10 }}>
          {
            leftAccessory ?
                <View style={AppConstants.STYLES.paddingRight10}>
                  {
                    leftAccessory
                  }
                </View>
              :
                null
          }
          <View style={{ flexShrink: 1 }}>
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ flexWrap: 'wrap', fontSize: 16, fontWeight: "800", paddingBottom: 3 }}>{item.title}</Text>
            </View>
            {
              item.description ?
                  <View style={{ flexDirection: 'row' }}>
                    <Text style={{ flexWrap: 'wrap', fontSize: 12, fontWeight: "400" }}>{item.description}</Text>
                  </View>
                :
                  null
            }
          </View>
        </View>
      </Pressable>
    );
  };

  return (
    <FlatList
      style={styles.mainList}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={styles.listWrapper}
      data={
        filteredProducers && filteredProducers.length > 0 ?
            filteredProducers.map((producer, index) => (
              {
                i: index,
                title: producer,
                description: "",
                onPress: () => {
                  searchProducer(producer);
                  navigation.navigate(AppConstants.SCREENS.MAP_STACK, { screen: AppConstants.SCREENS.MAP })
                },
              }
            ))
          :
            [ { i: "-1", title: filteredProducers ? "No matches" : "Loading..." } ]
      }
      ItemSeparatorComponent={Divider}
      renderItem={renderItem}
      ListHeaderComponent={(
        <View style={{ padding: 10 }}>
          <SearchLauncher floating={false} hideSearchLocation={true} />
        </View>
      )}
    />
  );
}
